import { connect } from 'react-redux';
import { keepState } from './../../../../../actions/appAction';
import { changeEditOrder, changeItemEditOrder, deleteOrderFromEditOrder, restoreOrder } from './../../../../../actions/editOrder';
import { searchCountry } from './../../../../../actions/getListCountry';
import { filterItemCode } from './../../../../../actions/getListItemName';
import ModalComponent from './../../../components/modal-component';
import './styles.css';

class Modal extends ModalComponent { }

const mapStateToProps = state => {
    return {
        isDisable: state.editOrder.isDisable,
        confirm_save_order: state.editOrder.confirm_save_order,
        itemOrder: state.editOrder.items,
        order: state.editOrder,
        information: state.editOrder.information,
        classes: state.editOrder.classes,
        listItemName: state.getListItemName,
        itemName: state.getListItemName
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChange: payload => {
            dispatch(changeEditOrder(payload))
        },
        onChangeItem: payload => {
            dispatch(changeItemEditOrder(payload))
        },
        deleteOrderFromEditOrder: payload => {
            dispatch(deleteOrderFromEditOrder(payload))
        },
        searchCountry: payload => {
            dispatch(searchCountry(payload))
        },
        filterItemCode: payload => {
            dispatch(filterItemCode(payload))
        },
        restoreOrder: payload => {
            dispatch(restoreOrder(payload))
        },
        keepState: payload => {
            dispatch(keepState(payload))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Modal)


// WEBPACK FOOTER //
// ./src/containers/orders/edit/components/modal/index.js